export default __webpack_public_path__ + "img/PenOutline.aa906dca.svg";